/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：DtRx
 */

var rng = require(/* i4uy */"./rng-i4uy")
var bytesToUuid = require(/* MAlW */"./bytesToUuid-MAlW")
function v4(options, buf, offset) {
  var i = buf && offset || 0
  if (typeof options == "string") {
    buf = options === "binary" ? new Array(16) : null
    options = null
  }
  options = options || {}
  var rnds = options.random || (options.rng || rng)()

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = rnds[6] & 0x0f | 0x40
  rnds[8] = rnds[8] & 0x3f | 0x80

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii]
    }
  }
  return buf || bytesToUuid(rnds)
}
module.exports = v4

/***/
